import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import ClientResponseForm from 'src/pages/QueryPages/QueryProfile/components/ClientResponseForm';

const SubmissionTab = ({ leadID, queryID, query, expert }) => (
  <Box sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Reporter submission
    </Typography>
    {query?.status === 'draft' ||
    query?.status === 'awaiting' ||
    query?.status === 'needsFollowUp' ||
    query?.status === 'clientNeedsEdits' ||
    query?.status === 'clientApproved' ? (
      <ClientResponseForm query={query} leadID={leadID} queryID={queryID} expert={expert} />
    ) : (
      <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
        {query.leads.find((lead) => lead.id === leadID)?.currentQueryText || ''}
      </Typography>
    )}
  </Box>
);

SubmissionTab.propTypes = {
  leadID: PropTypes.number.isRequired,
  queryID: PropTypes.number.isRequired,
  query: PropTypes.object.isRequired,
  expert: PropTypes.object.isRequired,
};

export default SubmissionTab;
